import { createContext } from 'react'
import { createContextualCan } from '@casl/react'

export AbilityContext = createContext()
export Can = createContextualCan AbilityContext.Consumer
export default AbilityContext.Consumer
